// extracted by mini-css-extract-plugin
export default {"menuJoin":"c-a_cT","menuJoin_show":"c-a_cU"};